import { styled } from '@spazious/dollhouse-theme';
import { PaletteColors, SizingNames } from '@spazious/dollhouse-theme';

import { BaseExtendProps, createBase } from '../Base/index.js';

export type TextAreaElement = HTMLTextAreaElement;
export interface TextAreaProps
  extends Omit<BaseExtendProps<React.TextareaHTMLAttributes<TextAreaElement>>, 'size' | 'color'> {
  color?: PaletteColors;
  size?: SizingNames;
  fullWidth?: boolean;
  resize?: 'vertical' | 'horizontal' | 'none' | 'both';
}

export const TextArea = styled(createBase('textarea')).withConfig({
  displayName: 'TextArea',
})<TextAreaProps>`
  --spacing-input-padding-small: 4px;
  --spacing-input-padding-medium: 8px;
  --spacing-input-padding-large: 12px;
  transition: background-color, color, box-shadow, border 0.3s ease-in-out;
  display: inline-flex;
  outline: none;
  border: none;
  margin: 0;
  padding: ${({ size = 'medium' }) => `var(--spacing-input-padding-${size})`};
  color: var(--spz-sys-color-on-surface);
  border-radius: var(--shape-rounded-radius);
  background-color: var(--spz-sys-color-surface);
  border: 1px solid var(--spz-sys-color-outline);
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  resize: ${({ resize }) => (resize ? resize : '')};
  ${({ color }) => color && `color: var(--spz-sys-color-${color});`}
  &:hover {
    color: var(--spz-sys-color-on-surface-variant);
    background-color: var(--spz-sys-color-surface-variant);
    border: 1px solid var(--spz-sys-color-surface-container-high);
  }
  &:focus {
    color: var(--spz-sys-color-on-surface-variant);
    background-color: var(--spz-sys-color-surface-variant);
    border: 1px solid var(--spz-sys-color-primary);
    box-shadow: 0 0 0 1px var(--spz-sys-color-primary);
  }
  ${({ disabled }) =>
    disabled &&
    `
    cursor: not-allowed !important;
    background-color: var(--spz-sys-color-surface-container-highest) !important;
    border: 1px solid var(--spz-sys-color-surface-container-high) !important;
  `}
`;
